import {
    callieVoiceRecording,
    hopeDefaultVoiceRecording,
    laurenVoiceRecording,
    loriVoiceRecording,
    sophieVoiceRecording,
} from "./voiceRecordingUrls";
import {
    callieSpanishVoice,
    hopeEnglishVoice,
    hopeSpanishVoice,
    laurenEnglishVoice,
    laurenSpanishVoice
} from "./voices";

export type SparkVoiceLanguage = "english" | "spanish";

export interface SparkVoiceOption {
    value: string
    label: string
    audioSrc?: string
    provider: "elevenlabs"
    /** The English voice string retained for existing telephony consumers. */
    voice: string
    englishVoice: string
    spanishVoice: string
}

const callieEnglishVoice = "voice_id=7YaUDeaStRuoYg3FKsmU|model_id=eleven_flash_v2_5|speed=1.10|stability=1|similarity_boost=.4";
const sophieEnglishVoice = "voice_id=AEW6JTgnyoPaoB9zlK3S|model_id=eleven_flash_v2_5|speed=1.1|stability=0.5|similarity_boost=0.75";
const sophieSpanishVoice = "voice_id=AEW6JTgnyoPaoB9zlK3S|model_id=eleven_multilingual_v2|speed=0.97|stability=0.86|similarity_boost=0.75";
const loriEnglishVoice = "voice_id=TbMNBJ27fH2U0VgpSNko|model_id=eleven_flash_v2_5|speed=1.1|stability=1|similarity_boost=0.4";
const loriSpanishVoice = "voice_id=TbMNBJ27fH2U0VgpSNko|model_id=eleven_multilingual_v2|speed=1.1|stability=1|similarity_boost=0.4";

export const voiceOptions: SparkVoiceOption[] = [
    {
        value: "Hope",
        label: "Hope",
        audioSrc: hopeDefaultVoiceRecording,
        provider: "elevenlabs",
        voice: hopeEnglishVoice,
        englishVoice: hopeEnglishVoice,
        spanishVoice: hopeSpanishVoice
    },
    {
        value: "Callie",
        label: "Callie",
        audioSrc: callieVoiceRecording,
        provider: "elevenlabs",
        voice: callieEnglishVoice,
        englishVoice: callieEnglishVoice,
        spanishVoice: callieSpanishVoice
    },
    {
        value: "Sophie",
        label: "Sophie",
        audioSrc: sophieVoiceRecording,
        provider: "elevenlabs",
        voice: sophieEnglishVoice,
        englishVoice: sophieEnglishVoice,
        spanishVoice: sophieSpanishVoice
    },
    {
        value: "Lauren",
        label: "Lauren",
        audioSrc: laurenVoiceRecording,
        provider: "elevenlabs",
        voice: laurenEnglishVoice,
        englishVoice: laurenEnglishVoice,
        spanishVoice: laurenSpanishVoice
    },
    {
        value: "Lori",
        label: "Lori",
        audioSrc: loriVoiceRecording,
        provider: "elevenlabs",
        voice: loriEnglishVoice,
        englishVoice: loriEnglishVoice,
        spanishVoice: loriSpanishVoice
    }
];

export const getSparkVoiceOption = (value: string): SparkVoiceOption | undefined => (
    voiceOptions.find(option => option.value === value)
);

const getSparkVoiceLanguageForLocale = (locale: string): SparkVoiceLanguage => {
    const normalizedLocale = locale.toLowerCase();
    const localeLanguage = normalizedLocale.split(/[-_]/)[0];
    return normalizedLocale === "spanish" || localeLanguage === "es"
        ? "spanish"
        : "english";
};

export const findSparkVoiceOptionByVoice = (
    voice: string,
    locale?: string
): SparkVoiceOption | undefined => {
    if (!locale) {
        return voiceOptions.find(option => (
            option.englishVoice === voice || option.spanishVoice === voice
        ));
    }

    const language = getSparkVoiceLanguageForLocale(locale);
    return voiceOptions.find(option => (
        language === "spanish"
            ? option.spanishVoice === voice
            : option.englishVoice === voice
    ));
};

export const getSparkVoiceString = (
    voice: string | SparkVoiceOption,
    language: SparkVoiceLanguage
): string | undefined => {
    const option = typeof voice === "string" ? getSparkVoiceOption(voice) : voice;
    if (!option) return undefined;

    return language === "spanish" ? option.spanishVoice : option.englishVoice;
};
